import * as React from 'react';

import {Button} from 'shells/button/button';
import {RightFrame, NavButtons, ModalMain} from 'shells/modal/step-modal/layout';
import {ModalHeader} from 'shells/typography/modal-header';

import {appHistory} from '../../../../history';

import {DoneScreen} from '../screens/done-screen';
import type {Method} from '../types';

import styles from './done.module.css';

type Props = {
    method: Method;
};

export function Done(props: Props) {
    const confettiCanvas = React.useRef(null);

    return (
        <RightFrame>
            <ModalMain>
                <ModalHeader>Two-factor authentication is enabled</ModalHeader>
                <DoneScreen method={props.method} canvasRef={confettiCanvas} />

                <canvas ref={confettiCanvas} className={styles['confetti-canvas']}></canvas>
            </ModalMain>
            <NavButtons>
                <Button
                    variant='primary'
                    size='big'
                    onClick={() => {
                        appHistory.push({
                            hash: '/',
                            search: location.search,
                        });
                        location.reload();
                    }}
                >
                    Done
                </Button>
            </NavButtons>
        </RightFrame>
    );
}
